const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  productInfoLoaded: 'product-info:loaded',
};

const DESKTOP_WIDTH = 1023;

const DEFAULT_SLIDER_SPEED = 1000;

const RELATED_PRODUCT_LIMIT = 15;

const RELATED_PRODUCT_INTENT = 'related';
